import config from "../config/app.conf.json";

export default (entityuId, uid) => ({
  url: `${config.api.permissions_service_url}/entities/${entityuId}/users/${uid}/statements`,
  method: "GET"
});